import { useEffect } from 'react'
import { initiateRedditPixel } from '@/utils/redditPixel'

export const useRedditPixel = (): void => {
    useEffect(() => {
        initiateRedditPixel()
    }, [])
}
